const selectMonth = async (selectedData, dataHouse) => {

    const { year, month } = selectedData; // Destructure year and month from the input object
    if (year === 0 && month === 0) {
        return dataHouse;  // Return the whole dataHouse array
    }
    // Validate input
    if (!year || !month || typeof year !== 'number' || typeof month !== 'number') {
        throw new Error("Invalid input: year and month should be numeric and non-null.");
    }

    // Filter data based on year and month
    const filteredData = dataHouse.filter((data) => {
        const date = new Date(data.created_at);
        const dataYear = date.getFullYear();
        const dataMonth = date.getMonth() + 1;

        return dataYear === year && dataMonth === month;
    });

    return filteredData;
};
const selectStatus = async (selectedData, dataHouse) => {

    if (typeof selectedData !== 'number') {

        if (selectedData.trim() === 'all') {
            // If the search term is all, return the whole array
            return dataHouse;
        }
    }
    else {
        const filteredMonthData = [];
        dataHouse.forEach((data) => {
            if (data.status === selectedData) {
                filteredMonthData.push(data);
            }
        });

        return filteredMonthData;
    }
};

export { selectMonth, selectStatus }